module.exports = __webpack_public_path__ + "img/proImg3.0f261f48.png";